<div
    class="product-details"
    *ngIf="productDetailService.productDetail$ | async as product"
    [ngClass]="{ loading: (productDetailService.productDetailLoading$ | async) }"
>
    <div class="brand-row" *ngIf="product.brand">
        <app-brand-link [compact]="true" [brand]="product.brand"></app-brand-link>
    </div>
    <h1 class="display-2">{{ product.productName }}</h1>
    <div class="display-label product-number">{{ product.variantNo }}</div>
    <hr class="kk-separator-line" />
    <form>
        <ng-container *ngIf="form?.controls && product.relatedProperties | hasRelatedProperties">
            <ng-container *ngIf="product.variantProducts?.items?.length">
                <app-product-related-properties
                    [formGroup]="form"
                    [relatedProperties]="product.relatedProperties"
                    [variants]="product.variantProducts?.items || []"
                    [selectedVariant]="product"
                ></app-product-related-properties>

                <hr class="kk-separator-line" />
            </ng-container>
        </ng-container>

        <div>
            <app-product-price [line]="product" [showAnydayPriceTag]="true"></app-product-price>
            <button
                *ngIf="(authenticationService.loginState$ | async)?.loggedIn === false"
                type="button"
                class="kk-link kk-link_underline"
                (click)="showLoginPrompt()"
            >
                {{ 'productDetail.becomeMember' | translateSafe }}
            </button>
        </div>
        <div class="quantity" *ngIf="product.stockQuantity > 0">
            <app-quantity [control]="quantity" [max]="product.stockQuantity"></app-quantity>
            <span class="display-caption quantity-reached" *ngIf="quantity.value === product.stockQuantity">{{
                    'stock.maxQuantityReached' | translateSafe
                }}</span>
        </div>
        <div class="buttons">
            <app-product-actions
                [amount]="quantity.value"
                [line]="product"
                (statusEvent)="onStatusEvent($event)"
            ></app-product-actions>
        </div>
    </form>

    <app-payment-methods></app-payment-methods>

    <ng-container *ngIf="!product.digitalProduct">
        <hr class="kk-separator-line" />
        <div class="stock-status">
            <div class="stock-online">
                <span class="stock-svg">
                    <app-svg-icon iconName="delivery"></app-svg-icon>
                </span>
                <app-store-stock-detailed [stockStatus]="product.stockStatus"></app-store-stock-detailed>
            </div>
            <div class="stock-store">
                <span class="stock-svg">
                    <app-svg-icon iconName="store"></app-svg-icon>
                </span>

                <ng-template #selectStore>
                    <button class="store-stock-button display-body" (click)="openStockOverlay()">
                        <span *ngIf="storesService.allStores$ | async as allStores">
                            {{
                                'stock.headings.stockStatus'
                                    | translateSafe
                                    | formatString
                                    : {
                                        storesWithStock: (
                                            product.storeStocks
                                                | storeMatches : allStores
                                                | storesWithStock
                                        ).toString()
                                    }
                            }}
                        </span>
                    </button>
                </ng-template>

                <ng-container *ngIf="storesService.favoriteStore$ | async as store; else selectStore">
                    <button
                        class="store-stock-button display-body"
                        [disabled]="(store.storeId | canChangeStoreInReservation : product.productNo | async) === false"
                        (click)="openStockOverlay()"
                    >
                        <span
                            *ngIf="storesService.favoriteStore$ | async as store; else selectStore"
                            class="store-stock-text"
                        >
                            <ng-container
                                *ngIf="
                                    store && (product.storeStocks | storeStock : store) >= 0;
                                    else unknownStockStatus
                                "
                            >
                                {{
                                    product.storeStocks
                                        | storeStockStatus : store
                                        | storeStockStatusTranslation
                                        | translateSafe
                                        | formatString : { storeName: store.storeName || '' }
                                }}
                                <app-stock-status
                                    [status]="(product.storeStocks | storeStockStatus : store) || 'NoStock'"
                                ></app-stock-status>
                            </ng-container>

                            <ng-container *ngIf="!store">
                                <span *ngIf="storesService.allStores$ | async as allStores">
                                    {{
                                        'stock.headings.stockStatus'
                                            | translateSafe
                                            | formatString
                                            : {
                                                storesWithStock: (
                                                    product.storeStocks
                                                        | storeMatches : allStores
                                                        | storesWithStock
                                                ).toString()
                                            }
                                    }}
                                </span>
                            </ng-container>
                            <ng-template #unknownStockStatus>
                                {{
                                    'productDetail.stock.unknownStockStatus'
                                        | translateSafe
                                        | formatString
                                        : {
                                            storeName: store.storeName || ''
                                        }
                                }}
                            </ng-template>
                        </span>
                    </button>

                    <app-tooltip
                        *ngIf="(store.storeId | canChangeStoreInReservation : product.productNo | async) === false"
                        [title]="'reservation.tooltip.title' | translateSafe"
                    >
                        <span [innerHTML]="'reservation.tooltip.text' | translateSafe"></span>
                    </app-tooltip>
                </ng-container>
            </div>
        </div>

        <!-- will render the content to a better sorting of the elements inside of it -->
        <ng-content></ng-content>

    </ng-container>

    <ng-container
        *ngIf="
            !product.digitalProduct &&
            !product.isGiftCard &&
            (settingsService.settings$ | async)?.ecommerceSettings as ecommerceSettings
        "
    >
        <ng-container *ngIf="ecommerceSettings?.giftCards?.length || ecommerceSettings?.giftWrappings?.length">
            <app-product-gift-options
                [amount]="quantity.value"
                [line]="product"
                [giftCardOptions]="ecommerceSettings?.giftCards || []"
                [giftWrappingOptions]="ecommerceSettings?.giftWrappings || []"
                [giftWrappingOptionsAllowed]="product.giftWrap || false"
            ></app-product-gift-options>
        </ng-container>
    </ng-container>
</div>
